// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormUploadHistoricalTransactions } from '../../forms/FormUploadHistoricalTransactions/FormUploadHistoricalTransactions';

// props
export interface DialogUploadHistoricalTransactionsProps {
	isOpen: boolean;
	onSuccess?: () => void;
	onClose: () => void;
}

export const DialogUploadHistoricalTransactions = ({
	isOpen,
	onClose,
	onSuccess,
}: DialogUploadHistoricalTransactionsProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('upload'),
					form: 'form-upload-historical-transactions',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			onClose={onClose}
			title={{
				children: t('uploadHistoricalTransactions'),
				variant: 'h3',
			}}>
			<FormUploadHistoricalTransactions
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
			/>
		</DialogActions>
	);
};
